import * as React from "react";
import { SVGProps } from "react";



type DeletePermitIconProps = SVGProps<SVGSVGElement> & {
  circleColor?: string;
  iconColor?: string;
};

const DeletePermitIcon = (props: DeletePermitIconProps) => {

    const { height = 32, width = 32, 
        circleColor = 'white', iconColor = 'black', ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="delete permit">
        <rect width={32} height={32} fill="white" />
        <g id="page">
          <g id="back-page">
            <path
              d="M24 2H9C8.44772 2 8 2.44772 8 3V5H21C21.5523 5 22 5.44772 22 6V25.9659C22 25.9847 22.0153 26 22.0341 26H24C24.5523 26 25 25.5523 25 25V3C25 2.44772 24.5523 2 24 2Z"
              fill="#D9D9D9"
            />
            <path
              d="M8 5V3C8 2.44772 8.44772 2 9 2H24C24.5523 2 25 2.44772 25 3V25C25 25.5523 24.5523 26 24 26H22.0341C22.0153 26 22 25.9847 22 25.9659V6C22 5.44772 21.5523 5 21 5H8Z"
              stroke="black"
              strokeWidth={0.5}
            />
          </g>
          <path
            id="front-page"
            d="M6 5H21C21.5523 5 22 5.44772 22 6V28C22 28.5523 21.5523 29 21 29H10.3837C10.1367 29 9.8984 28.9086 9.71477 28.7433L5.33104 24.7979C5.12032 24.6083 5 24.3381 5 24.0546V6C5 5.44772 5.44772 5 6 5Z"
            stroke="black"
            strokeWidth={0.5}
          />
          <path
            id="fold-page"
            d="M10 29V24.5C10 24.2239 9.77614 24 9.5 24H5"
            stroke="black"
            strokeWidth={0.5}
            strokeLinecap="round"
          />
        </g>
        <g id="lines">
          <g id="Line 49" filter="url(#filter0_d_15_618)">
            <line
              x1={8.5}
              y1={15.5}
              x2={15.5}
              y2={15.5}
              stroke="black"
              strokeLinecap="round"
            />
          </g>
          <g id="Line 49_2" filter="url(#filter1_d_15_618)">
            <line
              x1={8.5}
              y1={17.5}
              x2={12.5}
              y2={17.5}
              stroke="black"
              strokeLinecap="round"
            />
          </g>
          <g id="Line 50" filter="url(#filter2_d_15_618)">
            <line
              x1={8.5}
              y1={19.5}
              x2={11.5}
              y2={19.5}
              stroke="black"
              strokeLinecap="round"
            />
          </g>
          <g id="Line 55" filter="url(#filter3_d_15_618)">
            <line
              x1={8.5}
              y1={21.5}
              x2={11.5}
              y2={21.5}
              stroke="black"
              strokeLinecap="round"
            />
          </g>
          <g id="Line 54" filter="url(#filter4_d_15_618)">
            <line
              x1={8.5}
              y1={13.5}
              x2={18.5}
              y2={13.5}
              stroke="black"
              strokeLinecap="round"
            />
          </g>
          <g id="Line 56" filter="url(#filter5_d_15_618)">
            <line
              x1={8.5}
              y1={9.5}
              x2={18.5}
              y2={9.5}
              stroke="black"
              strokeLinecap="round"
            />
          </g>
          <g id="Line 57" filter="url(#filter6_d_15_618)">
            <line
              x1={8.5}
              y1={7.5}
              x2={18.5}
              y2={7.5}
              stroke="black"
              strokeLinecap="round"
            />
          </g>
          <g id="Line 58" filter="url(#filter7_d_15_618)">
            <line
              x1={8.5}
              y1={11.5}
              x2={18.5}
              y2={11.5}
              stroke="black"
              strokeLinecap="round"
            />
          </g>
        </g>
        <g id="circle">
          <circle
            id="inner-circle"
            cx={20.5}
            cy={23.5}
            r={7.25}
            fill={circleColor || "#D9D9D9"}
            stroke={iconColor || "black"}
            strokeWidth={0.5}
          />
          <path
            id="icon"
            d="M16.25 20.375C16.0429 20.375 15.875 20.5429 15.875 20.75C15.875 20.9571 16.0429 21.125 16.25 21.125V20.75V20.375ZM24.75 21.125C24.9571 21.125 25.125 20.9571 25.125 20.75C25.125 20.5429 24.9571 20.375 24.75 20.375V20.75V21.125ZM18.5 26.7531C18.5 26.9602 18.6679 27.1281 18.875 27.1281C19.0821 27.1281 19.25 26.9602 19.25 26.7531H18.875H18.5ZM19.25 22.2355C19.25 22.0284 19.0821 21.8605 18.875 21.8605C18.6679 21.8605 18.5 22.0284 18.5 22.2355H18.875H19.25ZM20.5 26.7531C20.5 26.9602 20.6679 27.1281 20.875 27.1281C21.0821 27.1281 21.25 26.9602 21.25 26.7531H20.875H20.5ZM21.25 22.2355C21.25 22.0284 21.0821 21.8605 20.875 21.8605C20.6679 21.8605 20.5 22.0284 20.5 22.2355H20.875H21.25ZM22.5 26.7531C22.5 26.9602 22.6679 27.1281 22.875 27.1281C23.0821 27.1281 23.25 26.9602 23.25 26.7531H22.875H22.5ZM23.25 22.2355C23.25 22.0284 23.0821 21.8605 22.875 21.8605C22.6679 21.8605 22.5 22.0284 22.5 22.2355H22.875H23.25ZM22 21H22.375V20H22H21.625V21H22ZM21 19V18.625H20V19V19.375H21V19ZM19 20H18.625V21H19H19.375V20H19ZM20 19V18.625C19.2406 18.625 18.625 19.2406 18.625 20H19H19.375C19.375 19.6548 19.6548 19.375 20 19.375V19ZM22 20H22.375C22.375 19.2406 21.7594 18.625 21 18.625V19V19.375C21.3452 19.375 21.625 19.6548 21.625 20H22ZM16.25 20.75V21.125H24.75V20.75V20.375H16.25V20.75ZM18.875 26.7531H19.25V22.2355H18.875H18.5V26.7531H18.875ZM20.875 26.7531H21.25V22.2355H20.875H20.5V26.7531H20.875ZM22.875 26.7531H23.25V22.2355H22.875H22.5V26.7531H22.875ZM24 21.5H23.625V27H24H24.375V21.5H24ZM23 28V27.625H18V28V28.375H23V28ZM17 27H17.375V21.5H17H16.625V27H17ZM18 28V27.625C17.6548 27.625 17.375 27.3452 17.375 27H17H16.625C16.625 27.7594 17.2406 28.375 18 28.375V28ZM24 27H23.625C23.625 27.3452 23.3452 27.625 23 27.625V28V28.375C23.7594 28.375 24.375 27.7594 24.375 27H24Z"
            fill={iconColor || "black"}
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_15_618"
          x={4}
          y={15}
          width={16}
          height={9}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_15_618"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_15_618"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_15_618"
          x={4}
          y={17}
          width={13}
          height={9}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_15_618"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_15_618"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_15_618"
          x={4}
          y={19}
          width={12}
          height={9}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_15_618"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_15_618"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_15_618"
          x={4}
          y={21}
          width={12}
          height={9}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_15_618"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_15_618"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_15_618"
          x={4}
          y={13}
          width={19}
          height={9}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_15_618"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_15_618"
            result="shape"
          />
        </filter>
        <filter
          id="filter5_d_15_618"
          x={4}
          y={9}
          width={19}
          height={9}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_15_618"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_15_618"
            result="shape"
          />
        </filter>
        <filter
          id="filter6_d_15_618"
          x={4}
          y={7}
          width={19}
          height={9}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_15_618"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_15_618"
            result="shape"
          />
        </filter>
        <filter
          id="filter7_d_15_618"
          x={4}
          y={11}
          width={19}
          height={9}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_15_618"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_15_618"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
export default DeletePermitIcon;
